import parse, { type HTMLReactParserOptions } from 'html-react-parser';
import showdown from 'showdown';

const converter = new showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
  disableForced4SpacesIndentedSublists: true,
});

const categoryRegex = /<category\s+id=["']?([^"'>/]+)["']?\s*\/>/g;
const quoteListSpacingRegex = /(^>.*\n)(?!\n)(?=(?:[-*+]|\d+\.)\s)/gm;
const orderedListItemRegex = /^\d+\.\s/;

export const stripStudioItemCategoryTags = (content: string) => {
  return content.replace(categoryRegex, '');
};

const addOrderedListSpacing = (content: string) => {
  const lines = content.split('\n');

  return lines
    .reduce<string[]>((normalizedLines, line, index) => {
      const previousLine = lines[index - 1]?.trim() ?? '';

      if (
        index > 0 &&
        orderedListItemRegex.test(line) &&
        previousLine &&
        normalizedLines[normalizedLines.length - 1] !== ''
      ) {
        normalizedLines.push('');
      }

      normalizedLines.push(line);
      return normalizedLines;
    }, [])
    .join('\n');
};

export const normalizeStudioItemMarkdown = (
  content: string,
  { stripCategories = false }: { stripCategories?: boolean } = {},
) => {
  const normalizedContent = addOrderedListSpacing(
    content.replace(quoteListSpacingRegex, '$1\n'),
  );

  if (!stripCategories) {
    return normalizedContent;
  }

  return stripStudioItemCategoryTags(normalizedContent);
};

export const studioItemMarkdownToHtml = (
  content: string,
  options?: { stripCategories?: boolean },
) => {
  return converter.makeHtml(normalizeStudioItemMarkdown(content, options));
};

export const StudioItemMarkdown = (props: {
  content: string;
  stripCategories?: boolean;
  options?: HTMLReactParserOptions;
}) => {
  const htmlContent = studioItemMarkdownToHtml(props.content, {
    stripCategories: props.stripCategories,
  });

  return parse(htmlContent, props.options);
};
